import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'
import $currency from 'currency.js'

interface OutsourceFeeModel {
  id: number;
  business: {
    id: number;
    orderId: number;
    [key: string]: any;
  };
  amount?: number;
  fee: number;
  customerOrderNo: string;
  outsourceCompany: string;
  account: {
    name: string;
    no: string;
    bank: string;
    bankNo: string;
    corporate: number;
    alias: string;
  };

  [key: string]: any;
}

export const TableField: TableFieldModel<OutsourceFeeModel>[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessNo',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '总费用',
    isMoney: true,
    textAlign: 'right',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'containsRate',
    fieldName: '是否含税',
    formatType: 'boolean',
    width: 60
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '税率',
    formatType: 'percent',
    width: 50
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'paymentAccount',
  //   fieldName: '付款账户'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompany',
    fieldName: '公司名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketCompany',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessBrand',
    fieldName: '业务品牌',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessName',
    fieldName: '业务名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessModel',
    fieldName: '型号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessSerial',
    fieldName: '序列号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessAmount',
    fieldName: '数量',
    width: 80
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessUnit',
    fieldName: '单位',
    width: 60
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee2',
    fieldName: '单价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const {
        orderFee,
        orderTaxRate
      } = rowData.business
      if (!orderFee) {
        return ''
      }
      return priceWithoutRate(orderFee, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      return rowData.business.orderFee
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee3',
    fieldName: '总价(未税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const {
        orderFee,
        orderTaxRate
      } = rowData.business
      if (!orderFee) {
        return ''
      }
      const { businessAmount } = rowData
      return totalPriceWithoutRate(orderFee, businessAmount, true, orderTaxRate)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee4',
    fieldName: '总价(含税)',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData.business
      const { businessAmount } = rowData
      return numberTimes(orderFee, businessAmount, true)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessRate',
    fieldName: '业务税率',
    width: 80,
    convert: context => {
      const { rowData } = context
      const { orderTaxRate } = rowData.business
      return orderTaxRate + '%'
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '发票号码'
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'code',
  //   fieldName: '发票代码'
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'checkCode',
  //   fieldName: '发票校验码'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '发票金额',
    textAlign: 'right',
    convert: context => {
      const { rowData } = context
      const { amount } = rowData
      if (!amount) {
        return ''
      }
      return $currency(amount)
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'returnAmount',
    fieldName: '已退票金额',
    isMoney: true,
    textAlign: 'right',
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceType',
    fieldName: '发票类型',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'date',
    fieldName: '开票时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'registerTime',
    fieldName: '开票时间'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesMan',
    fieldName: '业务代表',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.salesMan
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outsourceCompany',
    fieldName: '外包商'
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'accountAlias',
  //   fieldName: '外包商账户'
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '付款状态',
    width: 140
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceStatus',
    fieldName: '开票状态',
    width: 140
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessStatus',
    fieldName: '业务状态',
    width: 100,
    convert: context => {
      const { rowData } = context
      return rowData.business.status
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessReceivedStatus',
    fieldName: '收款状态',
    width: 120,
    convert: context => {
      const { rowData } = context
      return rowData.business.receivedStatus
    }
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessInvoiceStatus',
    fieldName: '开票状态',
    width: 120,
    convert: context => {
      const { rowData } = context
      return rowData.business.invoiceStatus
    }
  }
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'businessRepairStatus',
  //   fieldName: '维修状态',
  //   width: 120,
  //   convert: context => {
  //     const { rowData } = context
  //     return rowData.business.repairStatus
  //   }
  // }
]
